import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import dataTableGrid from "../DataTableGrid";
import {
  deleteData,
  getUserList,
  getSiteListByManufacturerID,
} from "../../Utils/adminFunctions";
import { getDataArr, getManufacturerName } from "../../Utils/commonFunctions";

let AdminListUsers = () => {
  const [selected, setSelected] = useState([]);
  const [listUsers, setListUsers] = useState([]);
  const [listSites, setListSites] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const { mID } = useParams();
  useEffect(() => {
    manageUser();
    getSites();
    getCompanyName();
  }, []);
  const getCompanyName = async () => {
    const tempManufacturerName = await getManufacturerName(mID);
    setCompanyName(tempManufacturerName);
  };
  const getSites = async () => {
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_ids", mID);
    const response = await getSiteListByManufacturerID(bodyFormData);
    if (response.status === "success") {
      setListSites(response.optionItems);
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };
  const manageUser = async () => {
    let selectedArr = getDataArr(selected);
    const bodyFormData = new FormData();
    bodyFormData.append("manufacturer_id", mID);
    bodyFormData.append("site_id", selectedArr);
    const response = await getUserList(bodyFormData);
    if (response.status === "success") {
      setListUsers(response.optionItems);
      dataTableGrid({
        data_table_id: "#userlist",
        paginate: false,
        copy_option: [0, 1, 2, 3, 4, 5, 6, 7],
        csv_option: [0, 1, 2, 3, 4, 5, 6, 7],
        print_option: [0, 1, 2, 3, 4, 5, 6, 7],
        sort_option: [8],
      });
    } else if (response.status === "failure") {
      setListUsers(response.optionItems);
    } else {
      toast.error(response, { autoClose: 1500 });
    }
  };

  const handleUserDeleteRecord = async () => {
    let uID = document.getElementById("deleteUser").value;
    const response = await deleteData(uID, "USERS");
    if (response.status == "success") {
      toast.success(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
      manageUser();
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      document.getElementById("close_modal").click();
    }
  };

  let filterSiteName = () => {
    if (selected.length == 0) {
      return false;
    }
    manageUser();
  };

  let refreshSiteName = () => {
    setSelected([]);
    selected.length = 0;
    manageUser();
  };

  return (
    <div>
      <div className="wrapper">
        <input type="hidden" id="deleteUser" value=""></input>
        <div className="modal fade show" id="modal-default" arial-modal="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Confirm delete</h4>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="close_modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this record?</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  data-dismiss="modal"
                  className="btn btn-sm btn-dark"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-danger"
                  onClick={() => handleUserDeleteRecord()}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div>
          
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-4">
                            <h3 className="card-title card-header-link custom-link-primary">
                              <b>{companyName} </b>{" "}
                            </h3>
                          </div>

                          <div className="col-md-3">
                            <MultiSelect
                              options={listSites}
                              value={selected}
                              onChange={(e) => {
                                setSelected(e);
                              }}
                              labelledBy="Select"
                            />
                          </div>
                          <div className="col-md-1">
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => filterSiteName()}
                            >
                              <i className="fa fa-search" aria-hidden="true" />{" "}
                            </button>
                            &nbsp;
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => refreshSiteName()}
                            >
                              <i className="fa fa-refresh" aria-hidden="true" />{" "}
                            </button>
                          </div>

                          <div className="col-md-4">
                            <h3 className="card-title pull-right ">
                              <Link
                                to={"/AdminAddUser/" + mID}
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-plus"></i> Add User
                              </Link>{" "}
                              <Link
                                to="/AdminListManufacturer"
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-arrow-left"></i> Back
                              </Link>
                            </h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <table
                          id="userlist"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Contact No.</th>
                              <th>User Type</th>
                              <th>Site Name</th>
                              <th>Status</th>
                              <th>Created On</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>{listUsers}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminListUsers;
